export default function Logo() {
  return (
    <div className="logo">
      <span role="img">🎬</span>
      <h1>React Movie App</h1>
    </div>
  );
}
